import { PayloadAction } from "@reduxjs/toolkit";

import { MapState } from "../../types";

export const setActiveExcise = (
  state: MapState,
  action: PayloadAction<MapState['routes']['activeExcise']>
) => {
  state.routes.activeExcise = action.payload;
}
